import { useSelector } from 'react-redux';

import { type SpartacuxRetentionState } from '@/retention/retention.model';

const guidesSelector = (state: SpartacuxRetentionState) =>
  state.retention?.homepage?.data?.guides || [];

export const useGuides = () => useSelector(guidesSelector);
